import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import {
  OfferListResponse,
  OfferResponse,
} from "../../../../orchestrator-api-client";

export const getOffersReducer = (
  state: LoanState,
  action: PayloadAction<OfferListResponse>,
) => {
  state.offers = action.payload.offers ?? [];
  state.offersAttempts = action.payload.offersAttempts ?? 0;
  state.offer = action.payload.offers?.find(
    (offer: OfferResponse) => offer.isSelected,
  );
};
